import { render, staticRenderFns } from "./MesasPage.html?vue&type=template&id=8dd57142&external"
import script from "./MesasPage.vue?vue&type=script&lang=ts"
export * from "./MesasPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports